<template>
    <div>
        <Header v-if="isRegistered"/>
        <div
            v-else
            class="form registration-form"
        >
            <MainForm
                :fields.sync="fields"
                :isLoading="isLoading"
                :syncErrors="syncErrors"
                :asyncErrors="asyncErrors"
                :asyncFieldError="asyncFieldError"
                :isPolish="isPolish"
                @submit="onRegisterClick"
            />
        </div>
    </div>
</template>

<script>
    import config from '@config';
    import {
        isRequired,
    } from '@modules/shared/validators/forms';
    import Logger from '@loggers/Logger';
    import Header from '@modules/authentication/components/register/Header';
    import MainForm from '@countryModules/authentication/components/register/MainForm';
    import RegisterMixin from '@modules/authentication/mixins/RegisterMixin';
    import { isPeselValid } from '@countryCore/validation';
    import { getDateFromPesel } from '@countryCore/utils';
    import PolandRegisterMixin from './mixins/PolandRegisterMixin';

    const polish = config.countrySpecific.auth.polishNationality;

    export default {
        mixins: [RegisterMixin, PolandRegisterMixin],
        data() {
            return {
                syncErrors: {},
                fields: {
                    nationality: {
                        value: null,
                        validate: [
                            isRequired,
                        ]
                    },
                    dateOfBirth: {
                        value: '',
                        validate: [
                            this.requiredIfNotPolish,
                        ],
                    },
                    customMarketingConsent: {
                        value: false,
                    },
                    receiveOperatorEmailConsent: {
                        value: false,
                        validate: [
                            this.requiredForMarketingConsent,
                        ],
                        // this is a hack, we must refactor forms completely
                        clearError: true,
                    },
                    receiveOperatorSMSConsent: {
                        value: false,
                        validate: [
                            this.requiredForMarketingConsent,
                        ],
                        // this is a hack, we must refactor forms completely
                        clearError: true,
                    },
                }
            };
        },
        created() {
            this.polishFields = {
                pesel: {
                    value: '',
                    validate: [
                        isRequired,
                        this.validatePesel
                    ],
                },
            };
            this.nonPolishFields = {
                ...this.addressFields,
                documentNumber: {
                    value: '',
                    validate: [
                        isRequired,
                    ],
                },
            };
        },
        watch: {
            'fields.county.value': function () {
                if (this.fields.city) {
                    this.fields.city.value = '';
                }
            },
            'fields.country.value': function () {
                if (this.fields.city) {
                    this.fields.city.value = '';
                }
            },
            'fields.nationality.value': function (value) {
                if (value === polish) {
                    this.updateFields(this.polishFields, this.nonPolishFields);
                } else {
                    this.updateFields(this.nonPolishFields, this.polishFields);
                }
            },
        },
        computed: {
            isPolish() {
                return this.fields.nationality.value === config.countrySpecific.auth.polishNationality;
            }
        },
        methods: {
            requiredIfNotPolish(value) {
                const nationality = this.fields.nationality.value;
                if (!nationality || nationality === polish) {
                    return false;
                }

                return isRequired(value);
            },
            requiredForMarketingConsent() {
                if (!this.fields.customMarketingConsent.value) {
                    return false;
                }

                if (!this.fields.receiveOperatorEmailConsent.value && !this.fields.receiveOperatorSMSConsent.value) {
                    return this.$t('You must choose either E-mail or SMS');
                }

                return false;
            },
            validatePesel(value) {
                return isPeselValid(value) ? false : this.$t('PESEL is incorrect');
            },
            beforeSubmit(result) {
                if (this.fields.pesel && this.fields.pesel.value) {
                    try {
                        // we wanna registration to submit never the less, date of birth can be set
                        // via customer support
                        result.dateOfBirth = getDateFromPesel(this.fields.pesel.value) || '';
                    } catch (e) {
                        Logger.error(e);
                    }
                }

                if (this.fields.termsAgree.value) {
                    result.ageConsent = true;
                }

                result.countryId = this.fields.country.value;
                delete result.country;
                result.documentTypeId = 'passport';
            },
            updateFields(fieldsToAdd, fieldsToRemove) {
                this.addFields(fieldsToAdd);
                this.removeFields(fieldsToRemove);
            }
        },
        components: {
            Header,
            MainForm,
        }
    };
</script>



// WEBPACK FOOTER //
// src/terminal/poland/app/modules/authentication/RegisterContainer.vue